(ns admin.components.composite.moment-editor.edit.details.cba-field
  (:require [reagent-form.core :as rf]

            [kyber.components.base.text :as text]
            [kyber.styles.core :refer [styles->classes gs]]

            [admin.components.forms.fields.toggle :as toggle]))

(def classes
  (styles->classes
   {:container
    {:padding-top (gs [:spacing :p20])
     :margin-top (gs [:spacing :p20])
     :border-top (str "1px solid " (gs [:colors :gray-scale-100]))}}))

(defn render
  [{:keys [has-correctness allow-disabling-of-cbqs confidence-enabled]}]
  (when (and (true? has-correctness)
             (true? allow-disabling-of-cbqs))
    [:div {:class (:container classes)}
     [text/caption-30 :label "Confidence Enabled"]
     [text/caption-10 :p
      {:style {:max-width "400px"}}
      (str "Confidence-based questions will prompt the learner to "
           "choose one of three confidence options prior to submitting "
           "a question response.")]

     (rf/custom-field
      {:render toggle/render
       :field-key :confidence
       :disabled (false? allow-disabling-of-cbqs)
       :default-value (if (some? confidence-enabled)
                        confidence-enabled
                        true)})]))
